import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  totalPopulation: null,
  loadingTotalPopulation: false
}

const totalUSPopulationSlice = createSlice({
  name: 'totalUSPopulation',
  initialState,
  reducers: {
    setTotalPopulation: (state, action) => {
      state.totalPopulation = action.payload
    },
    setLoadingTotalPopulation: (state, action) => {
      state.loadingTotalPopulation = action.payload
    },
    clearTotalUSPopulation: (state) => {
      state.totalPopulation = null
      state.loadingTotalPopulation = false
    }
  }
})

export const {setTotalPopulation, setLoadingTotalPopulation, clearTotalUSPopulation} = totalUSPopulationSlice.actions

// Selectors
export const selectTotalPopulation = (state) => state.totalUSPopulation.totalPopulation
export const selectLoadingTotalPopulation = (state) => state.totalUSPopulation.loadingTotalPopulation

export default totalUSPopulationSlice.reducer
